const LANGUAGE = Object.freeze({
  ko: 'ko',
  en: 'en',
  ja: 'ja',
  kr: 'kr', //20220721 --> (FE는 ko만 사용) 지우면 안됩니다.
});

export default LANGUAGE;
